import { render, staticRenderFns } from "./Htitle.vue?vue&type=template&id=986f2da4&scoped=true"
import script from "./Htitle.vue?vue&type=script&lang=js"
export * from "./Htitle.vue?vue&type=script&lang=js"
import style0 from "./Htitle.vue?vue&type=style&index=0&id=986f2da4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986f2da4",
  null
  
)

export default component.exports